import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { TableFooter, TablePagination } from '@mui/material'
import styles from './AllPortalsTable.module.scss'
import ClinicvuService from 'services/Clinicvu/Clinicvu.service'

const AllPortalsTable = () => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [portals, setPortals] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const fetchPortals = async () => {
      try {
        const res = await ClinicvuService.getAllOrganizations()
        setPortals(res.data)
      } catch (error) {
        console.error('Failed to fetch portals:', error)
      }
    }

    fetchPortals()
  }, [])
  const currentPortals =
    portals?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || []

  const handlePageChange = (e, newPage) => {
    setPage(newPage)
  }

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10)
    setRowsPerPage(newRowsPerPage)
    setPage(0)
  }

  const handleRowClick = (portalId) => {
    navigate(`/portals/${portalId}`)
  }

  return (
    <div className={styles.container}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid #dce3ea',
          boxShadow: '0 8px 24px rgba(18, 37, 56, 0.09)'
        }}
      >
        <Table aria-label="All Patients Table" className={styles.table}>
          <TableHead className={styles.table__head}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Timezone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPortals.map((portal, index) => (
              <TableRow
                className={styles.tablerow}
                key={index}
                onClick={() => handleRowClick(portal.id)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>{portal.name}</TableCell>
                <TableCell align="right">
                  {
                    portal.extension?.find(
                      (ext) =>
                        ext.url ===
                        'http://hl7.org/fhir/StructureDefinition/timezone'
                    )?.valueCode || '—'
                  }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleRowsPerPageChange}
                page={page}
                onPageChange={handlePageChange}
                count={portals?.length || 0}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  )
}

export default AllPortalsTable
